export const LinksForSideBar = [
    {
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
                <g fill="none">
                    <circle cx="11.92" cy="11.92" r="10" fill="#F1F1F1" />
                    <path
                        fill="#605F68"
                        d="M21.87 12.92a10.008 10.008 0 0 0 0-2h-3.03a6.919 6.919 0 0 0-.425-1.595l2.616-1.51a10.018 10.018 0 0 0-1.003-1.731l-2.616 1.51a7.04 7.04 0 0 0-1.167-1.167l1.51-2.616a10.018 10.018 0 0 0-1.731-1.003l-1.51 2.616A6.946 6.946 0 0 0 12.92 5V1.97c-.329-.032-.662-.05-1-.05-.338 0-.671.018-1 .05V5c-.555.08-1.09.222-1.595.425l-1.51-2.616a9.876 9.876 0 0 0-1.731 1.002l1.51 2.616a7.08 7.08 0 0 0-1.167 1.167l-2.616-1.51c-.389.54-.726 1.118-1.003 1.731l2.616 1.51A6.968 6.968 0 0 0 5 10.92H1.97c-.032.329-.05.662-.05 1 0 .338.018.671.05 1H5c.08.555.222 1.09.425 1.595l-2.616 1.51c.277.613.614 1.191 1.003 1.731l2.616-1.51a7.04 7.04 0 0 0 1.167 1.167l-1.51 2.616c.54.389 1.118.726 1.731 1.003l1.51-2.616a6.946 6.946 0 0 0 1.594.424v3.029a10.008 10.008 0 0 0 2 0V18.84a6.919 6.919 0 0 0 1.595-.425l1.51 2.616a10.018 10.018 0 0 0 1.731-1.003l-1.51-2.616a7.04 7.04 0 0 0 1.167-1.167l2.616 1.51c.389-.54.726-1.118 1.003-1.731l-2.616-1.51c.203-.505.345-1.04.425-1.595h3.029v.001zm-8.657 1.707-1.293-1.293-1.293 1.293a.997.997 0 0 1-1.414 0 .999.999 0 0 1 0-1.414l1.293-1.293-1.293-1.293a.999.999 0 1 1 1.414-1.414l1.293 1.293 1.293-1.293a.999.999 0 1 1 1.414 1.414l-1.293 1.293 1.293 1.293a.999.999 0 1 1-1.414 1.414z"
                    />
                </g>
            </svg>
        ),
        link: '',
    },
    {
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
                <g fill="none">
                    <path
                        fill="#F1F1F1"
                        d="m4.96 14.086 8.555-9.507c.288-.32.672-.539 1.095-.623l2.878-.576a1 1 0 0 1 1.178 1.177l-.576 2.878a1.998 1.998 0 0 1-.623 1.094L7.96 17.086l-3-3z"
                    />
                    <path
                        fill="#605F68"
                        d="m8.52 17.525-4-4a1.5 1.5 0 1 0-2.12 2.121l.938.94L1.4 18.525a1.5 1.5 0 1 0 2.122 2.122l1.939-1.94.939.939a1.495 1.495 0 0 0 2.122.001 1.502 1.502 0 0 0 0-2.122z"
                    />
                    <path
                        fill="#F1F1F1"
                        d="m22.488 18.525-1.94-1.939.94-.939a1.5 1.5 0 1 0-2.122-2.121l-4 4a1.5 1.5 0 1 0 2.122 2.121l.94-.939 1.938 1.939c.294.293.678.439 1.061.439a1.501 1.501 0 0 0 1.06-2.561z"
                    />
                    <path
                        fill="#605F68"
                        d="m18.87 14.022-8.5-9.443a1.994 1.994 0 0 0-1.093-.623L6.399 3.38A1 1 0 0 0 5.22 4.557l.577 2.879c.083.422.303.806.622 1.094l9.444 8.499 3.005-3.007z"
                    />
                </g>
            </svg>
        ),
        link: 'classic/start',
    },
    {
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
                <g fill="none">
                    <path
                        fill="#F1F1F1"
                        d="M19.945 5.36h-3.209a2.99 2.99 0 0 0-2.816-2h-9a3 3 0 0 0-3 3v11a3 3 0 0 0 3 3h9a2.99 2.99 0 0 0 2.816-2h3.209c.799 0 1.447-.648 1.447-1.447V6.807c0-.799-.648-1.447-1.447-1.447z"
                    />
                    <circle cx="5.42" cy="7.86" r="1.5" fill="#605F68" />
                    <circle cx="13.42" cy="7.86" r="1.5" fill="#605F68" />
                    <path
                        fill="#605F68"
                        d="M18.92 3.36h-5a3 3 0 0 1 3 3v11a3 3 0 0 1-3 3h5a3 3 0 0 0 3-3v-11a3 3 0 0 0-3-3zm0 6c-.552 0-1-.672-1-1.5s.448-1.5 1-1.5 1 .672 1 1.5-.448 1.5-1 1.5zm1 8c-.552 0-1-.672-1-1.5s.448-1.5 1-1.5 1 .672 1 1.5-.448 1.5-1 1.5z"
                    />
                    <circle cx="5.42" cy="15.86" r="1.5" fill="#605F68" />
                    <circle cx="13.42" cy="15.86" r="1.5" fill="#605F68" />
                </g>
            </svg>
        ),
        link: '',
    },
    {
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
                <g fill="none">
                    <path fill="#F1F1F1" d="M17.88 2.88h-12a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3v-12a3 3 0 0 0-3-3z" />
                    <path
                        fill="#605F68"
                        d="m16.88 7.183 3.749-2.499a3 3 0 0 0-1.6-1.564l.005-.008c-.035-.015-.074-.021-.11-.034a2.71 2.71 0 0 0-.31-.095c-.068-.017-.134-.036-.204-.049a3.025 3.025 0 0 0-.49-.049c-.014-.001-.026-.005-.04-.005h-12c-.014 0-.026.004-.04.004-.167.002-.33.021-.49.049-.069.013-.135.032-.203.049a2.93 2.93 0 0 0-.31.096c-.036.013-.075.019-.11.034l.004.008a2.997 2.997 0 0 0-1.6 1.564L6.88 7.183v7.697l-2.989 5.23c.53.474 1.222.77 1.989.77h12c.767 0 1.459-.296 1.989-.77l-2.989-5.23V7.183zm-7 7.697v-8h4v8h-4z"
                    />
                </g>
            </svg>
        ),
        link: 'rooms',
    },
];
export const TypingForSideBar = [
    {
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
                <g fill="none">
                    <path
                        fill="#605F68"
                        d="M21.92 15.4a3 3 0 0 1-3 3H9.89c-.628 0-1.239.196-1.75.56l-2.82 2.01c-1.43 1.02-3.4 0-3.4-1.74V5.4a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v10z"
                    />
                    <circle cx="11.92" cy="10.4" r="1.5" fill="#F1F1F1" />
                    <circle cx="16.92" cy="10.4" r="1.5" fill="#F1F1F1" />
                    <circle cx="6.92" cy="10.4" r="1.5" fill="#F1F1F1" />
                </g>
            </svg>
        ),
        link: '',
        classname: '',
    },
];
export const ButtonsForSideBar = [
    {
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
                <g fill="none">
                    <path fill="#F1F1F1" d="M9.12 19.2a2.88 2.88 0 1 0 5.76 0H9.12z" />
                    <path
                        fill="#605F68"
                        d="M18.72 10.24V8.922c0-3.68-2.835-6.888-6.514-6.999A6.719 6.719 0 0 0 5.28 8.64v1.6a6.718 6.718 0 0 1-1.344 4.033l-1.104 1.471A2.16 2.16 0 0 0 4.56 19.2h14.88a2.16 2.16 0 0 0 1.728-3.456l-1.104-1.471a6.72 6.72 0 0 1-1.344-4.032z"
                    />
                </g>
            </svg>
        ),
        link: '',
    },
    {
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
                <g fill="none">
                    <path fill="#F1F1F1" d="M12.44 9.88v4a2 2 0 0 0 0-4z" />
                    <path
                        fill="#605F68"
                        d="M11.102 2.991a2.005 2.005 0 0 0-2.224.64L5.479 7.878H4.44c-1.654 0-3 1.346-3 3v2c0 1.654 1.346 3 3 3h1.039l3.399 4.25a2 2 0 0 0 3.562-1.25v-14a2 2 0 0 0-1.338-1.888z"
                    />
                </g>
            </svg>
        ),
        link: '',
    },
    {
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
                <g fill="none">
                    <path
                        fill="#605F68"
                        d="M15.836 18.848a2.476 2.476 0 0 1 2.135-.164 1.414 1.414 0 0 0 1.592-.43 9.967 9.967 0 0 0 1.62-2.805c.222-.587.013-1.232-.466-1.638a2.471 2.471 0 0 1-.001-3.784c.479-.406.689-1.05.467-1.638a9.957 9.957 0 0 0-1.621-2.805 1.414 1.414 0 0 0-1.592-.43 2.472 2.472 0 0 1-3.344-1.937 1.398 1.398 0 0 0-1.143-1.158 9.832 9.832 0 0 0-3.294 0c-.587.1-1.052.57-1.143 1.158A2.472 2.472 0 0 1 5.7 5.155a1.414 1.414 0 0 0-1.592.43 9.964 9.964 0 0 0-1.62 2.805c-.222.587-.012 1.232.467 1.637.538.456.88 1.132.88 1.893 0 .761-.342 1.437-.88 1.893-.48.406-.69 1.05-.467 1.638a9.957 9.957 0 0 0 1.62 2.805 1.414 1.414 0 0 0 1.593.43 2.472 2.472 0 0 1 3.344 1.937c.09.588.556 1.058 1.143 1.158a9.832 9.832 0 0 0 3.294 0 1.395 1.395 0 0 0 1.143-1.158c.11-.719.53-1.382 1.21-1.775z"
                    />
                    <path fill="#F1F1F1" d="M11.836 7.92a4 4 0 1 0 0 8 4 4 0 0 0 0-8z" />
                </g>
            </svg>
        ),
        link: '',
    },
    {
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
                <g fill="none">
                    <path fill="#605F68" d="M11.92 2.92c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9zm0 13c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4z" />
                    <path
                        fill="#F1F1F1"
                        d="M11.42 1.92h1c.8 0 1.5.7 1.5 1.5v4c0 .8-.7 1.5-1.5 1.5h-1c-.8 0-1.5-.7-1.5-1.5v-4c0-.8.7-1.5 1.5-1.5zm-9.5 10.5v-1c0-.8.7-1.5 1.5-1.5h4c.8 0 1.5.7 1.5 1.5v1c0 .8-.7 1.5-1.5 1.5h-4c-.8 0-1.5-.7-1.5-1.5zm10.5 9.5h-1c-.8 0-1.5-.7-1.5-1.5v-4c0-.8.7-1.5 1.5-1.5h1c.8 0 1.5.7 1.5 1.5v4c0 .8-.7 1.5-1.5 1.5zm9.5-10.5v1c0 .8-.7 1.5-1.5 1.5h-4c-.8 0-1.5-.7-1.5-1.5v-1c0-.8.7-1.5 1.5-1.5h4c.8 0 1.5.7 1.5 1.5z"
                    />
                </g>
            </svg>
        ),
        link: '',
    },
];
